import { Theme, Form } from '@piconetworks/customization-serializer';

var themeSerializer = function themeSerializer(id) {
  return new Theme(id);
};
var formSerializer = function formSerializer(id) {
  return new Form(id);
};

export { formSerializer, themeSerializer };
//# sourceMappingURL=instantiate.js.map
